/**
 * Basically this file is just for abort control,
 * and to group API calls.
 * 
 * TODO: Replace with hooks
 * 
 */
import { components } from "./types";
import { loadInitialBundle } from "./bundles/initialBundle";
import { loadCorrelationsBundle } from "./bundles/correlationsBundle";
import { loadUserBundle } from "./bundles/userBundle";
import { loadFilterBundle } from "./bundles/filterOneBundle";
import { loadFilterTwoBundle } from "./bundles/filterTwoBundle";

type FilterParams = components["schemas"]["FilterParams"];

let initAC: AbortController | null = null;
let corrAC: AbortController | null = null;
let userAC: AbortController | null = null;
let popAC: AbortController | null = null;
let popTwoAC: AbortController | null = null;

export const onStart = () => {
  initAC?.abort();
  initAC = new AbortController();
  return loadInitialBundle();  //initAC.signal);
};

export const onCorrelationsLoad = (diagnosisNames: string[]) => {
  corrAC?.abort();
  corrAC = new AbortController();
  return loadCorrelationsBundle(diagnosisNames);  //, corrAC.signal);
};

export const onUserIdChange = (userId: string) => {
  userAC?.abort();
  userAC = new AbortController();
  return loadUserBundle(userId);  //, userAC.signal);
};

export const onOneFilterChange = (filter: FilterParams) => {
  popAC?.abort();
  popAC = new AbortController();
  return loadFilterBundle(filter);  //, popAC.signal);
};

export const onTwoFilterChange = (filter1: FilterParams, filter2: FilterParams) => {
  popTwoAC?.abort();
  popTwoAC = new AbortController();
  return loadFilterTwoBundle(filter1, filter2);  //, popTwoAC.signal);
};
